module.exports = __webpack_public_path__ + "img/loginimg.258b57d8.jpg";